import React, { useEffect, useState } from "react";
import queryString, { parse } from 'query-string';
import history from "../../history";
import raportorSecimListesi from "../../services/raportorSecimListesi";
import createBasvuruWithAltSurec from "../../services/createBasvuruWithAltSurec";
import addAtaEvent from "../../services/addAtaEvent";
import { Card, Row, Col, message, Spin, Form, Input, Select, Button, Tooltip as TooltipAnd } from 'antd';
import * as util from "../Helpers/Util";
import * as validation from "../BForm/validation";
const { Option } = Select;
const parsed = queryString.parse(history.location.search);
const formItemStyle = {
    marginLeft: 10
}
const formLayout = {
    labelCol: {
        span: 4
    },
    wrapperCol: {
        span: 8
    }
}
const RaportorSecimForm = () => {

    const [spining, setSpining] = useState(true);
    const [form] = Form.useForm();
    const [raportorList, setRaportorList] = useState([]);

    const { getFieldDecorator, getFieldValue } = form;

    const loadForm = async () => {
        setSpining(true);
        await raportorSecimListesi(parsed).then(resp => {
            if (resp.data.success) {
                setRaportorList(resp.data.result);
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch(ex => {
            util.errorMessage(String(ex.message));
        });
        setSpining(false);
    }
    useEffect(() => {
        loadForm();
    }, []);


    const onFinish = (values) => {
        setSpining(true);

        let data = [];
        let filterModel = {};

        let ataModel = {
            ParentBasvuruId: parsed.parentObjectId,
            AltSurecTipiIdList: [parsed.altSurecTipiId]
        };

        Object.keys(values).forEach(function (key) {
            if (!util.isNullOrEmptyOrUndefined(values[key])) {
                filterModel = {};
                filterModel.altSurecTipiId = key;
                filterModel.relAltSurecTipiId = parsed.altSurecTipiId;
                filterModel.parentObjectId = parsed.parentObjectId;
                filterModel.sorumluKullaniciId = values[key];
                data.push(filterModel);
            }
        });

        var secimKuralValidation = validation.raportorSecimKuralValidation(raportorList[0].secimKuralTuruId, values);
        if (secimKuralValidation.succes) {
            if(!util.isNullOrEmptyOrUndefined(data) ){
                createBasvuruWithAltSurec(data).then(resp => {
                    if (!resp.data.success) {                    
                        util.errorMessage(resp.data.message);
                        setSpining(false);
                    } else {
                        addAtaEvent(ataModel);
                        util.successMessage(resp.data.message);
                        setSpining(false);
                        window.parent.parent.location.reload();
                    }
                }).catch(ex => {
                    setSpining(false);
                    util.errorMessage(String(ex.message));
                });
            }else {
                addAtaEvent(ataModel).then(resp => {
                    if (!resp.data.success) {                    
                        util.errorMessage(resp.data.message);
                        setSpining(false);
                    } else {
                        util.successMessage(resp.data.message);
                        setSpining(false);
                        window.parent.parent.location.reload();
                    }
                }).catch(ex => {
                    setSpining(false);
                    util.errorMessage(String(ex.message));
                });
            }
          
           
        } else {
            setSpining(false);
            util.errorMessage(secimKuralValidation.message);
        }


    }


    return (
        <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
            <Card bodyStyle={{ padding: "10", fontWeight: "bold" }}>
                Raportör Seçim Formu
            </Card>
            <Form form={form}  {...formLayout} onFinish={onFinish}>
                {raportorList.map(key => (
                    <Form.Item key={key.raportorAltSurecTipiId} label={key.editorAdi} name={key.raportorAltSurecTipiId} style={formItemStyle} labelAlign="left">
                        <Select
                            showSearch
                            allowClear
                            defaultValue=
                            {key.sorumluKullaniciId != null ? key.sorumluKullaniciId : []}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            disabled={key.isReadonly}>
                            {key.kullaniciList && key.kullaniciList.map(bt => <Option key={key.kullaniciKodu} value={bt.kullaniciKodu}>{bt.adSoyad}</Option>)}
                        </Select>
                    </Form.Item>
                ))}
                <Row>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button type="primary" htmlType="submit">
                            Kaydet
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Spin>
    );
}

export default RaportorSecimForm;